"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "JumpToRef", {
  enumerable: true,
  get: function get() {
    return _types.JumpToRef;
  }
});
exports.default = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _JumpToMenu = _interopRequireDefault(require("./JumpToMenu"));

var _JumpToNav = _interopRequireDefault(require("./JumpToNav"));

var _schema = _interopRequireDefault(require("./schema"));

var _types = require("./types");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function JumpTo(props, ref) {
  var items = props.items,
      variant = props.variant;

  if ((0, _isEmpty.default)(items)) {
    return null;
  }

  return _react.default.createElement("div", null, variant === 'menu' ? _react.default.createElement(_JumpToMenu.default, _extends({
    ref: ref
  }, props)) : _react.default.createElement(_JumpToNav.default, _extends({
    ref: ref
  }, props)));
}

var JumpToWithRef = (0, _react.forwardRef)(JumpTo);
JumpToWithRef.displayName = 'JumpTo'; // @ts-ignore

JumpToWithRef.propTypes = _schema.default.propTypes;
var _default = JumpToWithRef;
exports.default = _default;